import { t } from "i18next";

export const eventsOptions = [
  {
    value: -1,
    name: t(`options_name:all_fire_messages`),
  },
  {
    value: 1,
    name: t(`options_name:fire_messages_amount`),
  },
  {
    value: 2,
    name: t(`options_name:false_fire_messages_amount`),
  },
];

export const bgColors = [
  { value: 2, color: "#FDE8E9" },
  { value: 3, color: "#FDE8E9" },
];
